/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react';
import ouiStyle from '@goldwasserexchange/oui-style';
import facepaint from 'facepaint';
import * as React from 'react';

const style: ouiStyle.InStyleWithMediaQueries = {
  display: ouiStyle.Constants.DisplayProp.flex,
  flexDirection: [
    ouiStyle.Constants.InFlexDirectionProp.col,
    undefined,
    undefined,
    ouiStyle.Constants.InFlexDirectionProp.row,
    undefined,
    undefined,
  ],
  backgroundColor: ouiStyle.Constants.Colors.accent,
  marginHorizontal: ['none', 'simple', undefined, undefined, undefined, 'none'],
  marginBottom: [1, undefined, undefined, 3, undefined, undefined],
};

export const FeatureArticleContainer = (props: React.PropsWithChildren<{
  marginBottom?: ouiStyle.InStyleWithMediaQueries['marginBottom'],
}>) => {
  const {
    marginBottom = style.marginBottom,
    children,
  } = props;
  const css = React.useMemo(
    () => facepaint([
      '@media only screen and (min-width: 34rem)',
      '@media only screen and (min-width: 40rem)',
      '@media only screen and (min-width: 48rem)',
      '@media only screen and (min-width: 62rem)',
      '@media only screen and (min-width: 81.5rem)',
    ])(ouiStyle.makeCss({
      ...style,
      marginBottom,
    })),
    [
      marginBottom,
    ],
  );
  return (
    <section
      css={css}
    >
      {children}
    </section>
  );
};
